import { contentAi } from '@mi-front/api-clients';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { useFragment } from '../../hooks/useFragment';
import { CreateFragmentContent } from './CreateFragmentContent';
import { FragmentContentLink } from './FragmentContentLink';

export function FragmentContentAiView() {
  const { fragment } = useFragment();
  const result = contentAi.useContentGetByKey(`FRAGMENT:${fragment.id}`, {
    query: {
      retry: (failureCount, error: any) => {
        return error?.axiosError?.response?.status !== 404;
      },
    },
  });

  return (
    <QueryView query={result} ignore404>
      {(data) => {
        if (!data) {
          return <CreateFragmentContent id={fragment.id} />;
        }

        return <FragmentContentLink content={result.data!} />;
      }}
    </QueryView>
  );
}
